import { useTranslationHelper } from '@shared/hooks/useTranslationsHelper';
import {
  MdcButton,
  MdcDrawer,
  MdcDrawerContent,
  MdcDrawerHeader,
  MdcGrid,
  MdcTypography
} from 'ids-wc/dist/react/components';
import { useEffect, useRef } from 'react';
import biometricsImage from '/biometrics.png';
import styles from './BiometricsSetupDrawer.module.css';

interface BiometricSetupDrawerProps {
  isOpen: boolean;
  onAccept: () => void;
  onDecline: () => void;
}

export const BiometricSetupDrawer = ({ isOpen, onAccept, onDecline }: BiometricSetupDrawerProps) => {
  const dialogRef = useRef<HTMLMdcDrawerElement>(null);
  const { t } = useTranslationHelper('biometricSetupModal');

  useEffect(() => {
    if (isOpen) {
      dialogRef.current?.open();
    } else {
      dialogRef.current?.close();
    }
  }, [isOpen]);

  return (
    <MdcDrawer
      ref={dialogRef}
      orientation={'bottom'}
      id="mdcDrawer"
      size="lg"
      drawerTitleId="biometric-setup-drawer"
      disableAutoFocus
      onMdcDrawerClose={onDecline}
      className={styles['biometrics-drawer']}
    >
      <MdcDrawerHeader className={styles['biometrics-drawer-header']}>
        <MdcGrid row justifyContent="center">
          <img alt="BiometricsImage" src={biometricsImage} className={styles['biometrics-image']} />
        </MdcGrid>
      </MdcDrawerHeader>
      <MdcDrawerContent>
        <MdcGrid row>
          <MdcGrid col={12}>
            <MdcTypography text={t('title')} variant="headline3" color="textPrimary" textAlign="left" />
          </MdcGrid>

          <MdcGrid col={12}>
            <MdcTypography text={t('description')} variant="body1" color="textPrimary" textAlign="left" />
          </MdcGrid>

          <MdcGrid col={12}>
            <MdcButton
              onClick={onAccept}
              label={t('accept')}
              color="primary"
              fullWidth
              disableFocusRing
              style={{ marginBlockEnd: 5 }}
            />
            <MdcButton
              onClick={onDecline}
              label={t('decline')}
              color="primary"
              variant="tertiary"
              fullWidth
              disableFocusRing
            />
          </MdcGrid>
        </MdcGrid>
      </MdcDrawerContent>
    </MdcDrawer>
  );
};
